import { render, staticRenderFns } from "./position-list.vue?vue&type=template&id=4e6585ff&scoped=true&"
import script from "./position-list.vue?vue&type=script&lang=js&"
export * from "./position-list.vue?vue&type=script&lang=js&"
import style0 from "./position-list.vue?vue&type=style&index=0&id=4e6585ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6585ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6585ff')) {
      api.createRecord('4e6585ff', component.options)
    } else {
      api.reload('4e6585ff', component.options)
    }
    module.hot.accept("./position-list.vue?vue&type=template&id=4e6585ff&scoped=true&", function () {
      api.rerender('4e6585ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_fee/form/position-list.vue"
export default component.exports